import React from "react";
import {
  ChevronDown,
  ChevronUp,
  HistoricalListContainer,
  MovementChevronContainer,
  MovementTitleContainer,
  MovimentItemCardBorder,
} from "../style";
import { TribunalIcon } from "@components/svgs";
import { LawsuitAppealIncident, Movement } from "@customTypes/responses/lawsuit";
import { WithPos } from "@customTypes/generics";
import { Text, Button } from "nectar-ui";
import { writeTitle } from "@pages/LawsuitPage/helper";
import { OrganizedMovements } from "@customTypes/pages/lawsuit";
import { useInfiniteQuery } from "react-query";
import { LawsuitStatusBadge } from "@components/pages/lawsuit";
import HistoricalsStateManagement from "../HistoricalStateManagement/HistoricalStateManagement";
import useAppealIncidentsTree from "@pages/LawsuitPage/hooks/useAppealIncidentsTree";
import { fetchLawsuitHistoricals } from "@services/lawsuit";
import { MoreButtonContainer } from "@pages/LawsuitListPage/style";

type AppealIncidentMovementItemProps = {
  movement: WithPos<LawsuitAppealIncident>;
  organizedMovements: OrganizedMovements;
};

const AppealIncidentMovementItem: React.FC<AppealIncidentMovementItemProps> = ({
  movement: appealIncident,
  organizedMovements,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { spaceBeforeCard, spaceBetweenCards } = useAppealIncidentsTree(
    appealIncident,
    organizedMovements
  );

  const movementId = appealIncident.id;

  const {
    data,
    isSuccess,
    isLoading,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery({
    queryKey: ["getMovementHistoricals", movementId],
    queryFn: ({ pageParam = "" }) => fetchLawsuitHistoricals({ lawsuitId: movementId, cursor: pageParam }),
    keepPreviousData: true,
    enabled: isOpen,
    getNextPageParam: (lastPage) => {
      return lastPage.cursor === "" ? undefined : lastPage.cursor;
    },
  });

  const caseTypesWithIcons: Movement["caseType"][] = ["CTE_APPEAL"];
  const shouldRenderIcon = caseTypesWithIcons.includes(appealIncident.caseType);
  const isActive = appealIncident.lawsuit.status === "ACTIVE";

  const handleClick = () => {
    setIsOpen((current) => !current);
  };

  const handleFetchMore = () => {
    fetchNextPage();
  };

  React.useEffect(() => {
    setIsOpen(isActive);
  }, [isActive]);

  return (
    <div>
      <div style={{ display: "flex" }}>
        {spaceBeforeCard}
        <MovimentItemCardBorder border onClick={handleClick}>
          <MovementTitleContainer>
            {shouldRenderIcon && <TribunalIcon style={{ scale: 1.3 }} />}
            <Text noMargin size="lg" semiBold>
              {writeTitle(appealIncident)}
            </Text>
            {isActive && <LawsuitStatusBadge status={appealIncident.lawsuit.status} />}
          </MovementTitleContainer>
          <MovementChevronContainer>
            {isOpen ? <ChevronUp /> : <ChevronDown />}
          </MovementChevronContainer>
        </MovimentItemCardBorder>
      </div>
      <div style={{ display: "flex", minHeight: 10 }}>
        {spaceBetweenCards}
        {isOpen && (
          <HistoricalListContainer>
            <HistoricalsStateManagement
              isLoading={isLoading}
              isSuccess={isSuccess}
              data={data}
            />
            {hasNextPage && (
              <MoreButtonContainer>
                <Button onClick={handleFetchMore} color="primary" reverse>
                  carregar mais andamentos
                </Button>
              </MoreButtonContainer>
            )}
          </HistoricalListContainer>
        )}
      </div>
    </div>
  );
};

export default AppealIncidentMovementItem;
